import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService, IMessageModel } from '@tencentcloud/chat-uikit-engine';
import { isUniFrameWork } from '../../../utils/env';

interface IProps {
  message: IMessageModel;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'message-room-default',
  props: {
    message: { default: () => ({} as IMessageModel) }
  },
  setup(__props: any) {

const props = __props as { message: IMessageModel }



return { __sfc: true,props, TUITranslateService, isUniFrameWork }
}

})